import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { ICONS } from 'src/constants/icons';
import { localeStore } from 'src/mobx/localesStore';
import { productsStore } from 'src/mobx/productsStore';
import { ICategory } from 'src/types/products';
import DropDown from 'src/view/components/Controls/DropDown/DropDown';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';
import { getTranslate } from '../../../../../../../utils/formatter';
import { IDropDownOption } from 'src/view/components/Controls/DropDownOption/DropDownOption';

@observer
class CategoriesDropDown extends Component {
  state = {};

  onDropDownPress = (option: IDropDownOption<ICategory>) => productsStore.setCategory(option.value.id);

  render() {
    if (!productsStore.categories || productsStore.categories.length < 7 || productsStore.loading) {
      return null;
    }

    return (
      <div className={`d-flex flex-row categories-dropdown ${productsStore.searchIsActive ? 'hidden' : ''}`}>
        <DropDown
          selected={productsStore.category?.id || 0}
          onPress={this.onDropDownPress}
          options={productsStore.categories.map((category: ICategory) => ({
            key: category.id,
            label: getTranslate(category.name),
            value: category,
          }))}
        >
          <div className="menu-category tab menu-category-dropdown family-semibold">
            {localeStore.t('txt_more')} <Icon className="ml-3" name={ICONS.CHEVRON} />
          </div>
        </DropDown>
      </div>
    );
  }
}

export default CategoriesDropDown;
